var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.25C9.91421 12.25 10.25 11.9142 10.25 11.5C10.25 11.0858 9.91421 10.75 9.5 10.75C9.08579 10.75 8.75 11.0858 8.75 11.5C8.75 11.9142 9.08579 12.25 9.5 12.25ZM12 4.5C12 4.3542 11.9364 4.21567 11.8257 4.12068C11.7151 4.02569 11.5686 3.98371 11.4244 4.00574L4.42445 5.07574C4.18032 5.11306 4 5.32303 4 5.57V16.43C4 16.6769 4.18028 16.8869 4.42438 16.9243L11.4244 17.9953C11.5685 18.0173 11.7151 17.9754 11.8257 17.8804C11.9363 17.7854 12 17.6468 12 17.501V11L17.1722 11L16.1753 11.8737C15.9679 12.0556 15.9468 12.3714 16.1284 12.5793C16.3099 12.7871 16.6253 12.8081 16.8328 12.6263L18.8295 10.8763C18.9379 10.7814 19 10.6442 19 10.5C19 10.3558 18.9379 10.2187 18.8295 10.1237L16.8328 8.37372C16.6253 8.19188 16.3099 8.21294 16.1284 8.42076C15.9468 8.62858 15.9679 8.94446 16.1753 9.1263L17.1723 10L12 10V4.5ZM11 5.08224V16.9187L5 16.0007V5.99938L11 5.08224ZM13.5 17H13V12H14V16.5C14 16.7761 13.7761 17 13.5 17ZM13 9V5H13.5C13.7761 5 14 5.22386 14 5.5V9H13Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.5d6527dc286ba2a8c5e03c20dd27de1b.svg";
export { ForwardRef as ReactComponent };